import React from 'react';

import AddImageIcon from '../../../assets/icons/add-image.svg';
import AddVideoIcon from '../../../assets/icons/add-video.svg';
import ArrowIcon from '../../../assets/icons/arrow.svg';
import ArrowLeftIcon from '../../../assets/icons/arrow-left.svg';
import ArrowRightIcon from '../../../assets/icons/arrow-right.svg';
import ArrowRightTopIcon from '../../../assets/icons/arrow-right-top.svg';
import BankIcon from '../../../assets/icons/bank.svg';
import BellIcon from '../../../assets/icons/bell.svg';
import BitcoinIcon from '../../../assets/icons/bitcoin.svg';
import BoardIcon from '../../../assets/icons/board.svg';
import BoldIcon from '../../../assets/icons/bold.svg';
import BoxIcon from '../../../assets/icons/box.svg';
import BuildingIcon from '../../../assets/icons/building.svg';
import CalendarIcon from '../../../assets/icons/calendar.svg';
import CashIcon from '../../../assets/icons/cash.svg';
import CertificationIcon from '../../../assets/icons/certification.svg';
import ChatIcon from '../../../assets/icons/chat.svg';
import CheckIcon from '../../../assets/icons/check.svg';
import CheckCircleIcon from '../../../assets/icons/check-circle.svg';
import ChevronDownIcon from '../../../assets/icons/chevron-down.svg';
import CoinIcon from '../../../assets/icons/coin.svg';
import CompareIcon from '../../../assets/icons/compare.svg';
import CopyIcon from '../../../assets/icons/copy.svg';
import CreditCardIcon from '../../../assets/icons/credit-card.svg';
import CrossIcon from '../../../assets/icons/cross.svg';
import CrossCircleIcon from '../../../assets/icons/cross-circle.svg';
import DiamondIcon from '../../../assets/icons/diamond.svg';
import DiscordIcon from '../../../assets/icons/discord.svg';
import DollarIcon from '../../../assets/icons/dollar.svg';
import DoorIcon from '../../../assets/icons/door.svg';
import DotIcon from '../../../assets/icons/dot.svg';
import DotsIcon from '../../../assets/icons/dots.svg';
import DotsSixIcon from '../../../assets/icons/dots-six.svg';
import Download from '../../../assets/icons/download.svg';
import EditIcon from '../../../assets/icons/edit.svg';
import EraserIcon from '../../../assets/icons/eraser.svg';
import ErrorIcon from '../../../assets/icons/error.svg';
import EyeIcon from '../../../assets/icons/eye.svg';
import EyeCrossedIcon from '../../../assets/icons/eye-crossed.svg';
import FacebookIcon from '../../../assets/icons/facebook.svg';
import FileIcon from '../../../assets/icons/file.svg';
import FileDocIcon from '../../../assets/icons/file-doc.svg';
import FileGifIcon from '../../../assets/icons/file-gif.svg';
import FileJpgIcon from '../../../assets/icons/file-jpg.svg';
import FileJsonIcon from '../../../assets/icons/file-json.svg';
import FilePdfIcon from '../../../assets/icons/file-pdf.svg';
import FilePngIcon from '../../../assets/icons/file-png.svg';
import FileSolidIcon from '../../../assets/icons/file-solid.svg';
import FileTxtIcon from '../../../assets/icons/file-txt.svg';
import FilterIcon from '../../../assets/icons/filter.svg';
import FolderIcon from '../../../assets/icons/folder.svg';
import FullscreenIcon from '../../../assets/icons/fullscreen.svg';
import GearIcon from '../../../assets/icons/gear.svg';
import GoogleIcon from '../../../assets/icons/google.svg';
import GridIcon from '../../../assets/icons/grid.svg';
import GroupIcon from '../../../assets/icons/group.svg';
import HeartIcon from '../../../assets/icons/heart.svg';
import HelpCircleIcon from '../../../assets/icons/help-circle.svg';
import HideIcon from '../../../assets/icons/hide.svg';
import HomeIcon from '../../../assets/icons/home.svg';
import ImagesIcon from '../../../assets/icons/images.svg';
import InboxIcon from '../../../assets/icons/inbox.svg';
import InfoIcon from '../../../assets/icons/info.svg';
import InfoCircleIcon from '../../../assets/icons/info-circle.svg';
import InstagramIcon from '../../../assets/icons/instagram.svg';
import ItalicIcon from '../../../assets/icons/italic.svg';
import LinkIcon from '../../../assets/icons/link.svg';
import LinkedinIcon from '../../../assets/icons/linkedin.svg';
import ListIcon from '../../../assets/icons/list.svg';
import LocationIcon from '../../../assets/icons/location.svg';
import LogoIcon from '../../../assets/icons/logo.svg';
import MailIcon from '../../../assets/icons/mail.svg';
import MedalIcon from '../../../assets/icons/medal.svg';
import MinusIcon from '../../../assets/icons/minus.svg';
import MobileIcon from '../../../assets/icons/mobile.svg';
import MonitorPlayIcon from '../../../assets/icons/monitor-play.svg';
import MoonIcon from '../../../assets/icons/moon.svg';
import MusicIcon from '../../../assets/icons/music.svg';
import NewsletterIcon from '../../../assets/icons/newsletter.svg';
import PaintIcon from '../../../assets/icons/paint.svg';
import PanoramaIcon from '../../../assets/icons/panorama.svg';
import PaperclipIcon from '../../../assets/icons/paperclip.svg';
import PauseIcon from '../../../assets/icons/pause.svg';
import PaypalIcon from '../../../assets/icons/paypal.svg';
import PlayIcon from '../../../assets/icons/play.svg';
import PlusIcon from '../../../assets/icons/plus.svg';
import PulseIcon from '../../../assets/icons/pulse.svg';
import RankingIcon from '../../../assets/icons/ranking.svg';
import RedoIcon from '../../../assets/icons/redo.svg';
import ReplyIcon from '../../../assets/icons/reply.svg';
import SearchIcon from '../../../assets/icons/search.svg';
import SendIcon from '../../../assets/icons/send.svg';
import ShareIcon from '../../../assets/icons/share.svg';
import ShieldIcon from '../../../assets/icons/shield.svg';
import ShowIcon from '../../../assets/icons/show.svg';
import SlidesIcon from '../../../assets/icons/slides.svg';
import SmileIcon from '../../../assets/icons/smile.svg';
import SpeakerIcon from '../../../assets/icons/speaker.svg';
import SpeakerSlashIcon from '../../../assets/icons/speaker-slash.svg';
import StarIcon from '../../../assets/icons/star.svg';
import StrikethroughIcon from '../../../assets/icons/strikethrough.svg';
import SuccessIcon from '../../../assets/icons/success.svg';
import SuitcaseIcon from '../../../assets/icons/suitcase.svg';
import SunIcon from '../../../assets/icons/sun.svg';
import TiktokIcon from '../../../assets/icons/tiktok.svg';
import TimeIcon from '../../../assets/icons/time.svg';
import TrashIcon from '../../../assets/icons/trash.svg';
import TwitterIcon from '../../../assets/icons/twitter.svg';
import UnderlineIcon from '../../../assets/icons/underline.svg';
import UndoIcon from '../../../assets/icons/undo.svg';
import UpdateIcon from '../../../assets/icons/update.svg';
import UploadIcon from '../../../assets/icons/upload.svg';
import UserIcon from '../../../assets/icons/user.svg';
import UserPlusIcon from '../../../assets/icons/user-plus.svg';
import VersionsIcon from '../../../assets/icons/versions.svg';
import WarningIcon from '../../../assets/icons/warning.svg';
import XIcon from '../../../assets/icons/x.svg';
import YoutubeIcon from '../../../assets/icons/youtube.svg';

const ICONS = {
  addImage: AddImageIcon,
  addVideo: AddVideoIcon,
  arrow: ArrowIcon,
  arrowLeft: ArrowLeftIcon,
  arrowRight: ArrowRightIcon,
  arrowRightTop: ArrowRightTopIcon,
  bank: BankIcon,
  bell: BellIcon,
  bitcoin: BitcoinIcon,
  board: BoardIcon,
  bold: BoldIcon,
  box: BoxIcon,
  building: BuildingIcon,
  calendar: CalendarIcon,
  cash: CashIcon,
  certification: CertificationIcon,
  chat: ChatIcon,
  check: CheckIcon,
  checkCircle: CheckCircleIcon,
  shield: ShieldIcon,
  coin: CoinIcon,
  compare: CompareIcon,
  copy: CopyIcon,
  chevronDown: ChevronDownIcon,
  creditCard: CreditCardIcon,
  cross: CrossIcon,
  crossCircle: CrossCircleIcon,
  diamond: DiamondIcon,
  discord: DiscordIcon,
  dollar: DollarIcon,
  door: DoorIcon,
  dots: DotsIcon,
  download: Download,
  edit: EditIcon,
  eraser: EraserIcon,
  error: ErrorIcon,
  eye: EyeIcon,
  eyeCrossed: EyeCrossedIcon,
  dot: DotIcon,
  dotsSix: DotsSixIcon,
  facebook: FacebookIcon,
  file: FileIcon,
  fileDoc: FileDocIcon,
  fileGif: FileGifIcon,
  fileJpg: FileJpgIcon,
  fileJson: FileJsonIcon,
  filePdf: FilePdfIcon,
  filePng: FilePngIcon,
  fileSolid: FileSolidIcon,
  fileTxt: FileTxtIcon,
  fullscreen: FullscreenIcon,
  gear: GearIcon,
  google: GoogleIcon,
  group: GroupIcon,
  grid: GridIcon,
  filter: FilterIcon,
  folder: FolderIcon,
  helpCircle: HelpCircleIcon,
  heart: HeartIcon,
  hide: HideIcon,
  home: HomeIcon,
  images: ImagesIcon,
  inbox: InboxIcon,
  info: InfoIcon,
  infoCircle: InfoCircleIcon,
  instagram: InstagramIcon,
  italic: ItalicIcon,
  link: LinkIcon,
  linkedin: LinkedinIcon,
  list: ListIcon,
  location: LocationIcon,
  logo: LogoIcon,
  mail: MailIcon,
  medal: MedalIcon,
  minus: MinusIcon,
  mobile: MobileIcon,
  music: MusicIcon,
  monitorPlay: MonitorPlayIcon,
  moon: MoonIcon,
  newsletter: NewsletterIcon,
  paint: PaintIcon,
  paperclip: PaperclipIcon,
  smile: SmileIcon,
  speaker: SpeakerIcon,
  speakerSlash: SpeakerSlashIcon,
  pause: PauseIcon,
  panorama: PanoramaIcon,
  paypal: PaypalIcon,
  play: PlayIcon,
  plus: PlusIcon,
  pulse: PulseIcon,
  ranking: RankingIcon,
  redo: RedoIcon,
  reply: ReplyIcon,
  search: SearchIcon,
  send: SendIcon,
  share: ShareIcon,
  show: ShowIcon,
  slides: SlidesIcon,
  star: StarIcon,
  strikethrough: StrikethroughIcon,
  success: SuccessIcon,
  suitcase: SuitcaseIcon,
  sun: SunIcon,
  time: TimeIcon,
  tiktok: TiktokIcon,
  trash: TrashIcon,
  twitter: TwitterIcon,
  underline: UnderlineIcon,
  undo: UndoIcon,
  update: UpdateIcon,
  upload: UploadIcon,
  user: UserIcon,
  userPlus: UserPlusIcon,
  versions: VersionsIcon,
  warning: WarningIcon,
  x: XIcon,
  youtube: YoutubeIcon,
};

export type IconType = keyof typeof ICONS;

interface Props extends React.SVGProps<SVGElement> {
  size?: number | string;
  icon: IconType;
}

export const Icon = ({ icon, size = 24, fill = 'currentcolor', className }: Props) => {
  const IconToRender = ICONS[icon];

  return <IconToRender className={className} width={size} height={size} viewBox="0 0 24 24" fill={fill} />;
};
